/**
 * created by lei lei
 *
 */
import *as utils from '../utils'
import {formateData} from "./index";
import {applicationName} from "../utils";
import request from "../base/request";

let host = "/cm-sites-" + applicationName() + '/';
let headers = {
    "Content-Type": 'application/json;charset=UTF-8'
};
let cacheAndcredentials = {cache: 'no-cache', /*credentials: 'include'*/};
//host = 'http://192.168.220.6:7898/cm-sites-media-matrix-service/';
const Apis = {
    topicSelectionList: host + 'topicSelection/list',//获取关联选题列表
    topicSelectionGetById: host + 'topicSelection/getById',//获取关联选题详情
    originalStoryList: host + 'originalStory/list',//获取原创稿件列表
    getCopyStoryMediaConllection: host + 'originalStory/getCopyStoryMediaConllection',//获取已发布拾取至数据
    originalStoryBindOrUnbind: host + 'originalStory/bindOrUnbind',//稿件绑定 | 解绑   选题 | 任务
    delStoryById: host + 'storyNew/delStoryById',//删除稿件
    downloadStoryById: host + 'storyNew/downloadStoryById',//下载稿件
    getWebsiteStoryPublishUrl: host + 'storyNew/getWebsiteStoryPublishUrl',//已发布媒体查看
    myInterviews: host + 'interview/myInterviews',//任务列表
    interviewGetById: host + 'interview/getById',//获取任务详情

};


//获取关联选题列表
export function topicSelectionList(body, callBack) {
    let url = Apis.topicSelectionList + utils.params(body)+'&time='+new Date().getTime();
    fetch(url, {
        method: 'get',
        ...cacheAndcredentials
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:topicSelectionList", error);
        callBack({});
    })
}

//获取关联选题详情
export function topicSelectionGetById(body, callBack) {
    let url = Apis.topicSelectionGetById + utils.params(body)+'&time='+new Date().getTime();
    fetch(url, {
        method: 'get',
        ...cacheAndcredentials
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:topicSelectionGetById", error);
        callBack({});
    })
}

//获取原创稿件
export function originalStoryList(body, callBack) {
    let url = Apis.originalStoryList;
    request({url, body, callBack, method:"post"});
}

//获取原创稿件
export function getCopyStoryMediaConllection(body, callBack) {
    let url = Apis.getCopyStoryMediaConllection;
    request({url, body, callBack});
}

//稿件绑定
export function originalStoryBindOrUnbind(body, callBack) {
    let url = Apis.originalStoryBindOrUnbind;
    request({url, body, callBack});
}

//删除稿件
export function delStoryById(body, callBack) {
    let url = Apis.delStoryById;
    request({url, body, callBack});
}

//下载稿件
export function downloadStoryById(body, callBack) {
    let url = Apis.downloadStoryById + utils.params(body);
    callBack(url)
}

//已发布媒体查看
export function getWebsiteStoryPublishUrl(body, callBack) {
    let url = Apis.getWebsiteStoryPublishUrl;
    request({url, body, callBack});
}

//获取任务列表
export function myInterviews(body, callBack) {
    let url = Apis.myInterviews;
    request({url, body, callBack});
}

//获取任务详情
export function interviewGetById(body, callBack) {
    let url = Apis.interviewGetById;
    request({url, body, callBack});
}
